import Api from "../utils/axios";

const requestFields: (keyof RequestJson | null)[] = [
  "transactionType", // 1
  "billingRefNumber", // 2
  "totalEFTAmount", // 3
  "programId", // 4
  "upiIdentifierData", // 5
  "upiInputType", // 6
  "invoiceNumber", // 7
  null,
  null,
  null,
  null, // 8-11 (skipped)
  "edcBatchId", // 12
  "edcRocId", // 13
];

const responseFields: (keyof ResponseJson | null)[] = [
  "billingRefId", // 1
  "approvalCode", // 2
  "hostResponse", // 3
  "cardNumber", // 4
  "expirationDate", // 5
  "cardHolderName", // 6
  "cardType", // 7
  "invoiceNumberOrEDC", // 8
  "batchNumberOrEDC", // 9
  "terminalId", // 10
  null, // 11 (skipped)
  "remark", // 12
  "transactionAcquirerName", // 13
  "merchantId", // 14
  "retrievalRefNumber", // 15
  null,
  null, // 16-17 (skipped)
  "merchantName", // 18
  "merchantAddress", // 19
  "merchantCity", // 20
  "plutusVersion", // 21
  "upiProgramType", // 22
  null,
  null,
  null,
  null,
  null,
  null, // 23-28 (skipped)
  "amountProcessed", // 29
  null,
  null, // 30-31 (skipped)
  "transactionDate", // 32
  "transactionTime", // 33
  "plutusTransactionId", // 34
  null,
  null,
  null, // 35-37 (skipped)
  "origBillDetails", // 38
];

// Types for request and response
interface RequestJson {
  transactionType?: string;
  billingRefNumber?: string;
  totalEFTAmount?: string;
  programId?: string;
  upiIdentifierData?: string;
  upiInputType?: string;
  invoiceNumber?: string;
  edcBatchId?: string;
  edcRocId?: string;
}

interface ResponseJson {
  billingRefId?: string;
  approvalCode?: string;
  hostResponse?: string;
  cardNumber?: string;
  expirationDate?: string;
  cardHolderName?: string;
  cardType?: string;
  invoiceNumberOrEDC?: string;
  batchNumberOrEDC?: string;
  terminalId?: string;
  remark?: string;
  transactionAcquirerName?: string;
  merchantId?: string;
  retrievalRefNumber?: string;
  merchantName?: string;
  merchantAddress?: string;
  merchantCity?: string;
  plutusVersion?: string;
  upiProgramType?: string;
  amountProcessed?: string;
  transactionDate?: string;
  transactionTime?: string;
  plutusTransactionId?: string;
  origBillDetails?: string;
}

function jsonToCsv<T>(
  json: Record<string, any>,
  fields: (keyof T | null)[]
): string {
  const maxLength = fields.length;
  const result: string[] = [];
  for (let i = 0; i < maxLength; i++) {
    const field: any = fields[i];
    result.push(field ? json[field] ?? "" : "");
  }
  return result.join(",");
}

function csvToJson<T>(csv: string, fields: (keyof T | null)[]): T {
  const values = csv?.split(",");
  const json = {} as T;
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    if (field && values[i] !== "") {
      json[field] = values[i] as any;
    }
  }
  return json;
}

const usePineLabs = () => {
  const doTransaction = async (request: any) => {
    const transformedRequest = jsonToCsv<RequestJson>(request, requestFields);

    const res: any = await Api.post(
      `${process.env.REACT_APP_PINELABS_HOST}/web/doTransaction`,
      transformedRequest,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return csvToJson(res, responseFields);
  };

  const createUpiTransaction = (amount: string, transactionId: string) => {
    const request: RequestJson = {
      transactionType: "5120",
      billingRefNumber: transactionId,
      totalEFTAmount: amount,
    };
    return doTransaction(request);
  };

  const createCardTransation = (amount: string, transactionId: string) => {
    const request: RequestJson = {
      transactionType: "4001",
      billingRefNumber: transactionId,
      totalEFTAmount: amount,
    };
    return doTransaction(request);
  };

  return { createUpiTransaction, createCardTransation };
};

export default usePineLabs;
